import React from 'react';
import { StaticQuery, Link, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';


import PorkKingLogo from '../img/PorkKingSmall.png';
import PigIcon from '../img/pigIcon.png';
import FaceBookLogo from '../img/facebook_square.svg';

import '../styles/main.scss';

function toggleNav() {
	const toggleNav = document.getElementById('navi-toggle').checked;
	//console.log(toggleNav);
	if(toggleNav === false) {
		document.getElementById('navi-toggle').checked = true;
	}
	else {
		document.getElementById('navi-toggle').checked = false;
	}
}

export default ({children}) => (
	<StaticQuery
		query={graphql`
			query {
				site {
					siteMetadata {
						company
						description
						subDescription
						metaDescription
					}
				}
			}
		`}
		render={data => (
			<div className="container">
				<Helmet>
					<html lang="en" />
					<meta charSet="utf-8" />
					<title>{data.site.siteMetadata.company}</title>
					<meta name="description" content={data.site.siteMetadata.metaDescription} />
					<meta name="theme-color" content="#8C1D1C"/>

          			<meta property="og:title" content={data.site.siteMetadata.company} />
          			<meta property="og:description" content={data.site.siteMetadata.metaDescription} />
          			<meta property="og:image" content={PorkKingLogo} />
          			<meta property="og:url" content="http://www.pksausage.com" />

          			<link rel="shortcut icon" href={PigIcon} />
          			<link href="https://fonts.googleapis.com/css?family=Roboto:400,500" rel="stylesheet" />

				</Helmet>
				<div className="content">
					<nav className="nav">
						<input type="checkbox" className="nav__checkbox" id="navi-toggle" />
						<label htmlFor="navi-toggle" className="nav__button" aria-haspopup="true" role="button" tabIndex="0" aria-label="navigation menu" onKeyPress={()=>toggleNav()}>
							<span className="nav__icon">&nbsp;</span>
						</label>
							<ul className="nav__list">
								<div className="nav__item-container">
									<li className="nav__item-1"><Link to="/"          className="nav__link">Home</Link></li>
									<li className="nav__item-2"><Link to="/products/" className="nav__link">Products</Link></li>
									<li className="nav__item-3"><Link to="/contact/"  className="nav__link">Contact</Link></li>
								</div>
							</ul>
					</nav>
					<header className="header">
						<div className="header__logo-box">
							<img className="header__logo" src={PorkKingLogo} alt="Pork King"/>
						</div>
						<div className="header__title-box">
							<h1 className="header__title">{data.site.siteMetadata.company}</h1>
							<h1 className="header__description">{data.site.siteMetadata.subDescription}</h1>
							<h2 className="header__description">{data.site.siteMetadata.description}</h2>
						</div>
					</header>
					{children}
				</div>
				<footer className="footer">
					<div className="footer__fb">
						<span>Find Us On Facebook</span>
						<a href="https://www.facebook.com/Pork-King-Sausage-151231358267347/"><img src={FaceBookLogo} alt="find us on facebook"/></a>
					</div>
				</footer>
			</div>
		)}
	/>
);
